import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Hgroup.module.scss";

const Hgroup = ({ heading, subheading, children, className }) => (
  <div className={classnames(styles.hgroup, className)}>
    <h2 className={styles.hgroup__heading}>{heading}</h2>
    {subheading && (
      <div className={styles.hgroup__subheading} dangerouslySetInnerHTML={{ __html: subheading }} />
    )}
  </div>
);

Hgroup.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  className: PropTypes.string
};

export default Hgroup;
